module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._l((_vm.records), function(record) {
    return _c('div', {
      key: record.id,
      staticClass: "post full-width"
    }, [_c('b', [_vm._v(_vm._s(record.date))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.pick))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.side))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.price))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.risk))]), _vm._v("\n         \n        "), _c('b', [_vm._v("units")]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.towin))]), _vm._v("\n           \n        "), _c('b', [_vm._v(_vm._s(record.result))]), _vm._v("\n           \n        "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "sml-btn blue",
      attrs: {
        "to": {
          path: '/admin/record/' + record.record_id
        }
      }
    }, [_vm._v("\n          Edit\n        ")]), _vm._v(" "), _c('a', {
      staticClass: "sml-btn orange",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.remove(record)
        }
      }
    }, [_vm._v("Delete")]), _vm._v(" "), _c('a', {
      staticClass: "sml-btn green",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'W')
        }
      }
    }, [_vm._v("Win")]), _vm._v(" "), _c('a', {
      staticClass: "sml-btn red",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.update(record, 'L')
        }
      }
    }, [_vm._v("Loss")])], 1)
  }), _vm._v(" "), _c('p', [(!_vm.hideMore) ? _c('button', {
    staticClass: "big-btn blue",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.next()
      }
    }
  }, [_vm._v("\n          More ->\n        ")]) : _vm._e()])], 2), _vm._v(" "), _c('div', {
    attrs: {
      "id": "sidebar"
    }
  }, [_c('ul', [_c('li', {
    staticClass: "widget"
  }, [_vm._m(0), _vm._v(" "), (_vm.results) ? _c('div', {
    staticClass: "content"
  }, _vm._l((_vm.results), function(result) {
    return _c('p', {
      key: result.id
    }, [_vm._v("\n              " + _vm._s(result.name) + ":\n              "), _c('b', [_vm._v(_vm._s(result.win) + "-" + _vm._s(result.loss) + " " + _vm._s(result.units) + " units\n                " + _vm._s(Number(result.win_percent).toFixed(2) * 100) + "%W")])])
  })) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title"
  }, [_c('h5', [_vm._v("Record")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bda5260!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/ManageRecord.vue
// module id = 504
// module chunks = 1